module.exports = __webpack_public_path__ + "img/dongji_ps_30.d011f990.jpg";